import { ErrorLayout } from '@uag/react-core';
import { FallbackProps } from 'react-error-boundary';

export const DefaultErrorBoundaryFallback = ({ error }: Omit<FallbackProps, 'resetErrorBoundary'>) => {
    return <ErrorLayout description={error.message} />;
};
